import React from 'react';
import { useBoolean } from 'react-hanger';
import cls from 'classnames';

import { ItemProps } from '../types';
import Styled from './styled';

const Textarea = (props: ItemProps) => {
  const {
    className,
    label,
    placeholder,
    name,
    value = '',
    maxLength,
    onChange,
    onBlur,
  } = props;

  const isValChange = useBoolean(false);
  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(e, isValChange.value);
    }
  };

  return (
    <Styled.Textarea className={cls('form-item form-item-textarea', className)}>
      <label className="form-item-label">{label}</label>
      <div className="form-item-input">
        <textarea
          className="scroll-bar"
          placeholder={placeholder || `请输入${label}`}
          maxLength={maxLength || 300}
          name={name}
          value={value}
          onBlur={handleBlur}
          onChange={(e) => {
            isValChange.setTrue();
            return onChange(name, e.target.value);
          }}
        />
        {maxLength > 0 && (
          <span className="form-item-counter">
            {value.length}/{maxLength}
          </span>
        )}
      </div>
    </Styled.Textarea>
  );
};

export default Textarea;
